import { render, staticRenderFns } from "./TaskMigration.vue?vue&type=template&id=29efee6c&"
import script from "./TaskMigration.vue?vue&type=script&lang=js&"
export * from "./TaskMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports